import ExcelJS from "exceljs";

function exportExcel(columns, rows, filename = "export") { // Génère un export excel
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('sheet', {
    pageSetup: { paperSize: 1, orientation: 'landscape' }
  });

  const realColumns = columns.filter(col => col.label) // On enlève les colonnes qui contiendront des actions (button, etc.)

  // Ajouter l'en-tête
  ws.addRow(realColumns.map(col => col.label));

  // Ajouter les données avec formatage
  rows.forEach(row => {
    const rowData = realColumns.map(col => row[col.field]);
    const excelRow = ws.addRow(rowData);

    // Appliquer le format pour chaque cellule
    realColumns.forEach((col, colIndex) => {
      const cell = excelRow.getCell(colIndex + 1);
      if (col.format === 'currency') {
        cell.numFmt = '#,##0.00 €';
      } else if (col.format === 'percentage') {
        cell.numFmt = '0.00%';
      }
    });
  });

  // Mettre en forme l'en-tête
  ws.getRow(1).font = { bold: true };
  ws.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFD9D9D9' }
  };

  // Ajuster la largeur des colonnes
  ws.columns.forEach((column, index) => {
    let maxLength = 10;
    const header = realColumns[index].label;
    maxLength = Math.max(maxLength, header.length);
    column.width = maxLength + 2;
  });

  saveWb(wb, filename);
}
// Télécharge le fichier excel
function saveWb(wb, name, useDatetime = true) {
  wb.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    var datetimeString = "";
    if (useDatetime) {
      const now = new Date();
      datetimeString = "-" + now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear() + " " + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
    };
    saveAs(blob, name + datetimeString + ".xlsx");
  })
}

export default {
  exportExcel,
  saveWb
}

export {
  exportExcel,
  saveWb
}



// WEBPACK FOOTER //
// ./src/utils/exportExcel.js